module.exports = __webpack_public_path__ + "static/media/compatibility.a9780c87.svg";